import { useFeatureQuery } from '@common/hooks/query/useFeatureQuery';
import {
    BaseFeatureArgs,
    FixedFilterGenerator,
    InitialQueryState,
    QueryManagerOptions,
    SkipOrArgs,
} from '@common/types/queryState';
import { useSelectedProductionId } from '@features/productions';
import { skipToken } from '@reduxjs/toolkit/query';
import { useMemo } from 'react';
import { useGetClipsQuery } from '../api';
import { GetClipsArgs } from '../types';
import { CLIP_KEYS } from '../constants';
import { composeGenerators } from '@common/utils';

export type UseClipsArgs = BaseFeatureArgs; //Omit<GetClipsArgs, 'productionId'>;

const clipFilterGenerator: FixedFilterGenerator<GetClipsArgs> = () => {
    return [
        // 'funnel:MediaObjectAnnotation',
        '-packageId:[* TO *]',
    ];
};

export const useClips = (
    initialArgs: InitialQueryState = {},
    args?: SkipOrArgs<UseClipsArgs>,
    options?: QueryManagerOptions,
) => {
    const productionId = useSelectedProductionId();

    const queryArgs: SkipOrArgs<GetClipsArgs> = useMemo(() => {
        if (args === skipToken || !productionId) return skipToken;
        const mergedGenerators = composeGenerators(
            clipFilterGenerator,
            args?.fixedFilterGenerators,
        );

        return {
            ...args,
            productionId,
            sorting: [{ id: 'mediaObjectName', desc: false }],
            // facetFields: ['codec', 'container', 'size'],
            searchTargetFields: ['clipName'],
            keyMap: CLIP_KEYS,
            fixedFilterGenerators: mergedGenerators,
        } as GetClipsArgs;
    }, [args, productionId]);

    return useFeatureQuery(initialArgs, useGetClipsQuery, queryArgs, options);
};
